import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { _AdquisitionItemByPaa } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicPage } from "../../theme/Component/BasicPage";



interface Props {
    idProject: any;
}

export const AdquisitionItemByPaa = ({ idProject }: Props) => {

    const bypaa = useDataBean(_AdquisitionItemByPaa);
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();

    useEffect(() => {
        getListavdos();
    }, [paginador.page, idProject])

    const head = [
        { title: 'ID PAA', property: 'IDAdquisitionItem', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Justificación', property: 'Justification', visible: true },
        { title: 'Valor Estructurado', property: 'StructuredValue', visible: true },
        { title: 'Valor Total', property: 'TotalValue', visible: true },
        { title: 'Estado Estructuración', property: 'StructuringStateName', visible: true, mask: MASK_MONEY },
        { title: 'Estado Planeación', property: 'PlanningStateName', visible: true, mask: MASK_MONEY },
        { title: 'Estado Contratación', property: 'HiringStateName', visible: true },
        { title: 'Area Funcional Planificación', property: 'IDLnFunctionalIDName', visible: true },
        { title: 'Preparador Area Funcional', property: 'PreparerName', visible: true },
        { title: 'Iniciativa', property: 'IDLnProjectIDName', visible: true },
        { title: 'Modalidad Contratación', property: 'IDHiringModalityName', visible: true },
        { title: 'Recurso Presupuestal', property: 'IDBudgetResourceName', visible: true },
        { title: 'Rubros Presupuestales', property: 'IDLnBudgetIDNameList', visible: true },
    ]

    const getListavdos = () => {

        bypaa.instance.getAdquisitionItemByProject(idProject, null, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    return (
        <div className="row">
            <BasicPage titulo="Catálogo de PAA">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={bypaa.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                </div>
            </BasicPage>


        </div>
    )
}